
import * as React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const IconLeft = () => <ChevronLeft className="h-4 w-4" />;
export const IconRight = () => <ChevronRight className="h-4 w-4" />;
